import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-javascript";
import "ace-builds/src-noconflict/mode-html";
import "ace-builds/src-noconflict/mode-css";
import "ace-builds/src-noconflict/theme-monokai";
import Git1 from '../img/git1.png';
import Git2 from '../img/git2.png';
export const Git = () =>{


    return(
    
        <div id="articleContent" className="git">
                    <h2>Installer Git sur son poste de travail</h2>
                <ul>
                    <li>Télécharger l'installateur de Git pour Windows ici <a href="https://gitforwindows.org/" target="_blank">https://gitforwindows.org/</a> et l'exécuter</li>
                    <li>Ouvrir un terminal (l'invite de commande) et entrer la commande suivante : <strong className="highlight">git config --global
                        user.name "Prénom Nom" git config --global user.email "votreemail@votreemail.com"</strong></li>
                </ul>
                <h2>Démarrer un dépôt Git</h2>
                <p>2 possibilité pour démarrer un dépôt Git :</p>
                <ul>
                    <li>Récuperer un projet ou un répertoire existant et l'initialiser dans Git</li>
                    <li>Cloner un dépôt Git existant sur un autre serveur</li>
                </ul>
                <h3>Répertoire existant</h3>
                <p>Un dépôt local est composé de trois arbres gérés par Git. Le premier est l'espace de travail, qui
                    contient réellement les fichiers, le second un Index, qui joue un rôle d'espace de transit pour les
                    fichiers et le dernier un HEAD qui pointe vers la dernière validation.</p>
                <img className="center" src={Git1} width="500px" alt="Les trois arbres gérés par Git"/>
                <h4>Initialiser le projet Git :</h4>
                <ul>
                    <li className="info"><strong className="highlight">git --version</strong> : Permet de s'assurer que Git est bien installé sur son poste (à ne faire
                        qu'une fois)</li>
                    <li><strong className="highlight">cd</strong> : Se positionner dans le répertoire du projet à l'aide de cette commande</li>
                    <li><strong className="highlight">git init</strong> : créé un nouveau sous-répertoire nommé .git qui contient tous les fichiers
                        nécessaires au dépôt.</li>
                </ul>
                <h4>Démarrer le contrôle de version sur les fichiers existants en ajoutant des fichiers ou des
                    changements des fichiers existants :</h4>
                <ul>
                    <li><strong className="highlight">git add *</strong> : Va ajouter tous les fichiers présents dans l'Index ou les changement de tous les
                        fichiers existants</li>
                    <li><strong className="highlight">git add nomFichier</strong> : Permet d'ajouter un nouveau fichier dans l'Index ou un changement d'un
                        fichier existant</li>
                    <li className="info"><strong className="highlight">git status</strong> : Permet de vérifier l'état des fichiers</li>
                    <li className="info"><strong className="highlight">git log</strong> : Permet de voir la timeline des commits</li>
                </ul>
                <h4>Valider ces changements :</h4>
                <ul>
                    <li><strong className="highlight">git commit -m "Détail sur la modification apporté"</strong> : Permet d'ajouter ces changements au HEAD,
                        c'est à dire d'enregister l'état de mon projet actuel (c'est comme une photo du projet)</li>
                </ul>
                <h4>Cloner un dépôt local ou distant</h4>
                <ul>
                    <li>Se positionner dans le nouveau directory vide</li>
                    <li><strong className="highlight">git clone /chemin/du/repository/à/cloner</strong> : Pour cloner un repository local</li>
                    <li><strong className="highlight">git clone username@host:/chemin/du/repository/à/cloner</strong> : Pour cloner un repository distant
                    </li>
                </ul>
                <h2>Les branches</h2>
                <p>Les branches sont utilisées pour développer des fonctionnalités isolées des autres. La branche master
                    est la branche par défaut quand un dépôt est créé. Il faut créer des branches pour le développement
                    et les fusionner ensuite à la branche principale quand le développement est terminé.</p>
                    <img className="center" src={Git2} width="500px" alt="Les trois arbres gérés par Git"/>
                <ul>
                    <li><strong className="highlight">git checkout -b newBranche</strong> : Pour créer une nouvelle branche nommé newBranche</li>
                    <li>Faire ses modifications dans le fichier en question</li>
                    <li><strong className="highlight">git add nomFichier</strong> : Va ajouter le fichier modifier dans l'Index</li>
                    <li><strong className="highlight">git commit -m "détails sur la modification"</strong> : Permet d'ajouter ces changements au HEAD de la
                        branche dans laquelle nous nous trouvons</li>
                    <li><strong className="highlight">git checkout master</strong> : Pour retourner à la branche principale ou sur une autre branche</li>
                </ul>
                <h4>Les étapes pour rapatrier la modification apportée dans une branche sur le master</h4>
                <ul>
                    <li><strong className="highlight">git checkout master</strong> : Retourner à la branche principale</li>
                    <li><strong className="highlight">git merge nomBranche</strong> : Pour fusionner les commits</li>
                    <li className="info"><strong className="highlight">git log</strong> : Pour vérifier que tout est ok</li>
                    <li><strong className="highlight">git branch -d nomBranche</strong> : Pour supprimer la branche qui n'est plus utile</li>
                    <li className="info"><strong className="highlight">git branch</strong> : Pour faire une vérification des branches</li>
                    <li className="info"><strong className="highlight">git diff brancheSource brancheCible</strong> : Permet d'avoir un aperçu des changements</li>
                </ul>
                <p className="todo">??? Comment annuler une modification à rédiger plus tard</p>

                <h2>Dépôt distant sur Github</h2>
                <p>Voici les étapes à suivre pour déposer un projet sur Github :</p>
                <ul>
                    <li>Créer un nouveau repository en cliquant sur le + en haut à droite > New repository</li>
                    <li>L'associer le dépôt distant au dépôt local en suivant les instructions présente dans Github
                        "...or push an existing repository from the commande line" (remplacer main par master) :
                        <br /><strong className="highlight">git remote add origin https://github.com/MalikaLeroy/githubGuide.git</strong>
                        <br /><strong className="highlight">git branch -M master</strong>
                        <br /><strong className="highlight">git push -u origin master</strong>
                    </li>
                    <li>Saisir son username et son psw Github</li>
                </ul>
                <p className="important"><strong className="highlight">git push origin nomBranche</strong> : Pour envoyer les changements au dépôt distant</p>
                <p className="important"><strong className="highlight">git pull origin nomBranche</strong> : Pour récupérer un projet ou les changements du dépôt distant</p>
                <p className="info">Pour donner les droits d'écriture sur Github, aller sur setting et ajouter le nom de la personne.</p>
      </div>
    )
}
